import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";

import { AddOrderServiceProvider } from "./../../pages/addorder/add-order.service";

import { APIServiceProvider } from "./../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";

@Component({
	selector: "modal-maddress",
	templateUrl: "./modal-maddress.html"
})
export class MAddressModalPage {
	public type_address: any = "state";
	address_type_list: any = [];

	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		public addOrderService: AddOrderServiceProvider,
		public helperService: HelperServiceProvider,
		public apiService: APIServiceProvider,
		public navParams: NavParams
	) {
		this.type_address = navParams.get("type");
	}

	public items: any = [];

	dismiss() {
		this.viewCtrl.dismiss();
	}

	ionViewDidLoad() {
		this.items = [];

		if (this.type_address == "district") {
			if (this.addOrderService.all_district.length !== 0) {
				this.addOrderService.m_all_district = this.addOrderService.all_district;
			}
		}

		if (this.type_address == "tehsil") {
			if (this.addOrderService.all_tehsil.length !== 0) {
				this.addOrderService.m_all_tehsil = this.addOrderService.all_tehsil;
			}
		}

		if (this.type_address == "village") {
			if (this.addOrderService.all_village.length !== 0) {
				this.addOrderService.m_all_village = this.addOrderService.all_village;
			}
		}
	}

	filterAddressItem(data, value) {
		if (!data) return [];
		if (!value) return data;
		value = value.toLowerCase();
		this.items = data.filter(it => {
			return it.toLowerCase().includes(value);
		});

		return this.items;
	}

	selectMissingAddress(value) {
		this.addOrderService.missingAddressData[this.type_address] = value;

		if (this.type_address === "district") {
			this.addOrderService.m_all_tehsil = [];
			this.addOrderService.m_all_village = [];
		}

		if (this.type_address === "tehsil") {
			this.addOrderService.m_all_village = [];
		}

		this.dismiss();
	}

	selectAddressTypeValue(value) {
		this.addOrderService.missingAddressData[this.type_address] = value;

		if (this.type_address === "pincode") {
			this.dismiss();
			return false;
		}

		if (this.type_address === "village") {
			this.dismiss();
			return false;
		}

		let addressInfo: any = {};

		addressInfo.state_name = value;

		if (this.type_address === "state") {
			addressInfo.state_name = value;
			addressInfo.searchon = "district_name";

			this.addOrderService.missingAddressData.district = null;
			this.addOrderService.missingAddressData.tehsil = null;
			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;
		}

		if (this.type_address === "district") {
			addressInfo.state_name = this.addOrderService.missingAddressData.state;
			addressInfo.district_name = this.addOrderService.missingAddressData.district;

			this.addOrderService.missingAddressData.tehsil = null;
			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;

			addressInfo.searchon = "tehsil_name";
		}

		if (this.type_address === "tehsil") {
			addressInfo.state_name = this.addOrderService.missingAddressData.state;
			addressInfo.district_name = this.addOrderService.missingAddressData.district;
			addressInfo.tehsil_name = this.addOrderService.missingAddressData.tehsil;

			this.addOrderService.missingAddressData.village = null;
			this.addOrderService.missingAddressData.pincode = null;

			addressInfo.searchon = "village_name";
		}

		this.apiService
			.post("customer/address/info", addressInfo)
			.subscribe(response => {
				var result = response["data"];

				if (this.type_address === "state") {
					this.addOrderService.m_all_district = [];
					this.addOrderService.m_all_district = result;
				}

				if (this.type_address === "district") {
					this.addOrderService.m_all_tehsil = [];
					this.addOrderService.m_all_tehsil = result;
				}

				if (this.type_address === "tehsil") {
					this.addOrderService.m_all_village = [];
					this.addOrderService.m_all_village = result;
				}
			});

		this.dismiss();
	}
}



// WEBPACK FOOTER //
// ./src/modals/maddress/maddress.modal.ts